import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  InputAdornment,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Typography
} from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import {
  commonTableHeaderIcon,
  keywordOverviewCss,
  KeywordOverviewResultCardsCss,
  KeywordOverviewTableCss
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import HelpIcon from '@mui/icons-material/Help';
import { RootState } from 'src/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import BackLinksRow from './BackLinksRow';
import { ListDataTableCss } from '../keywordResearch/keywordsLists/KeywordListsCss';
import {
  BackLinkAllTexts,
  backLinkDrOptions,
  backLinkSpamScoreOptions,
  backLinkTooltips
} from './BackLinkAllTexts';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import CommonModal from 'src/common/config/CommonModal';
import { ExportCsvModal } from '../keywordResearch/ExportCsvModal';
import { openNewTab, timeConverter } from 'src/common/config/FunctionHelper';
import Papa from 'papaparse';
import { ExportCsvPopOver } from '../keywordResearch/ExportCsvPopOver';
import CloseIcon from '@mui/icons-material/Close';
import {
  setbackLinkFilteredData,
  setBackLinkFilters
} from 'src/redux/keywordResearch';
import { BackLinkAllCss } from './BackLinkCss';
import { CustomTooltip } from '../keywordResearch/CustomTooltip';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import { keywordOverviewTexts } from 'src/common/config/TextMessage';
import { CustomDropdown } from 'src/common/CustomPopover';
import { CustomPopoverCss } from 'src/common/CustomPopoverCss';
const StyledTableCell = ({ children, minwidth = '0px' }) => (
  <TableCell>
    <Typography
      variant="body1"
      sx={{
        ...KeywordOverviewTableCss?.tableHeadText
      }}
    >
      {children}
    </Typography>
  </TableCell>
);

const BacklinksDataTable = ({
  rowData,
  loader,
  getBackLinksDetailsFunc,
  getMoreLoader,
  nextToken,
  getIsMore,
  searchedUrl
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [exportType, setExportType] = useState('1000');
  const [customRange, setCustomRange] = useState(null);
  const [csvFormat, setCsvFormat] = useState('csv1');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [orderDirection, setOrderDirection] = useState('asc');
  const [valueToOrderBy, setValueToOrderBy] = useState('');
  let userDetails: any = useSelector(
    (state: RootState) => state?.counter?.userDetails
  );
  const backLinkData: any =
    useSelector((state: RootState) => state.keywordResearch.backLinkData) ?? [];
  const backLinkFilteredData: any =
    useSelector(
      (state: RootState) => state.keywordResearch.backLinkFilteredData
    ) ?? [];
  const backLinkFilters: any =
    useSelector((state: RootState) => state.keywordResearch.backLinkFilters) ??
    [];
  const [filteredRowData, setFilteredRowData] = useState(
    backLinkFilteredData || []
  );
  const [filterState, setFilterState] = useState(null);
  const [backupFilteredRowData, setBackupFilteredRowData] = useState(null);
  useEffect(() => {
    //setFilteredRowData(rowData);
    dispatch(setbackLinkFilteredData(rowData));
  }, [rowData]);
  useEffect(() => {
    let updated = backLinkFilteredData;
    if (selectedFilter) {
      updated = backLinkFilteredData?.filter(
        (row) => row?.linkAttribute?.toLowerCase() === selectedFilter
      );
    }
    setFilteredRowData(updated);
  }, [backLinkFilteredData]);

  useEffect(() => {
    if (filterState == null) {
      setBackupFilteredRowData(filteredRowData);
    }
  }, [filterState, filteredRowData]);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const headers = [
    'Linking Page',
    'DA',
    'Spam Score %',
    'Anchor Text and Target URL',
    'Link Type',
    'First Seen',
    'Lost'
  ];
  const columnToDataKeyMap = {
    'Linking Page': 'linkingPage',
    DA: 'dr',
    'Spam Score %': 'spamScore',
    'Anchor Text and Target URL': 'anchorText',
    'Link Type': 'linkType',
    'First Seen': 'firstSeen',
    Lost: 'lost'
  };
  useEffect(() => {
    setPage(0);
    const filtered = filterData(backLinkFilters, rowData);
    dispatch(setbackLinkFilteredData(filtered));
  }, [backLinkFilters]);

  const handleChangePage = (event: unknown, newPage: number) =>
    setPage(newPage);
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleExportModalClose = () => {
    setOpenExportModal(false);
  };

  const getHostname = (url) => {
    if (!url) return null;

    let hostname = url.replace(/^https?:\/\//, '');
    hostname = hostname.replace(/^www\./, '');

    return hostname;
  };

  const exportToCSV = () => {
    const headers = [
      'Linking Page + URL',
      'DA',
      'Spam Score',
      'Anchor Text + Target URL',
      'Link Type',
      'First Seen',
      'Lost'
    ];

    const sliceRange =
      exportType === 'custom' && customRange?.length > 0
        ? Number(customRange)
        : 1000;
    const dateFormat = userDetails?.date_format || 'DD/MM/YYYY';
    const dataToExport = filteredRowData?.slice(0, sliceRange)?.map((row) => {
      const referringPageWithUrl = `${row?.referringPage || '-'}\n${
        row?.referringUrl || '-'
      }`;
      const anchorWithTarget = row?.targetUrl
        ? `${row?.anchorText || '-'}\n${row?.targetUrl}`
        : row?.anchorText || '-';

      const firstSeen = row?.firstSeen
        ? timeConverter(row?.firstSeen, dateFormat)
        : '-';

      const lost = row?.lost ? 'Yes' : 'No';

      return [
        referringPageWithUrl,
        row?.dr || '-',
        row?.spamScore || '-',
        anchorWithTarget,
        row?.linkAttribute || '-',
        firstSeen,
        lost
      ];
    });

    const csvData = Papa.unparse({
      fields: headers,
      data: dataToExport
    });

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${getHostname(searchedUrl)}-backlink-data.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportBtnClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCustomRange(null);
  };

  const handleExport = () => {
    setOpenExportModal(true);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const parseRange = (range) => {
    if (!range) return [null, null];

    // Remove commas, percent signs, and trim
    range = range.replace(/,/g, '').replace(/%/g, '').trim();

    // Handle the case where the range includes a "+"
    if (range.includes('+')) {
      let min = Number(range.replace('+', '').trim());
      return [min, Infinity];
    }

    // Handle the case like "0 to 30" or "0% to 30%"
    if (range.includes('to')) {
      let [min, max] = range.split('to').map((r) => Number(r.trim()));
      return [min, max ?? Infinity];
    }

    // Default numeric range with "-"
    let [min, max] = range.split('-').map((r) => Number(r.trim()));
    max = max ? max : Infinity;

    return [min, max];
  };

  // Function to filter data based on the filter object
  const filterData = (filters, data) => {
    if (!filters || Object?.keys(filters)?.length === 0) return [...data]; // Return a new copy of the data array
    if (!data || data?.length === 0) return [];

    const [minVolume, maxVolume] = parseRange(filters?.searchVolume);
    const [minKd, maxKd] = parseRange(filters?.kd);
    const [minGoldenKR, maxGoldenKR] = parseRange(filters?.keywordGoldenRation);
    const [minWordCount, maxWordCount] = parseRange(filters?.wordCount);
    const [minPosition, maxPosition] = parseRange(filters?.position);
    const [minSpamScore, maxSpamScore] = parseRange(filters?.spamScore);
    return data?.filter((item) => {
      const volumeMatch =
        (!minVolume && !maxVolume) ||
        (item?.volume >= minVolume && item?.volume <= maxVolume);
      const kdMatch =
        (!minKd && !maxKd) || (item?.kd >= minKd && item?.kd <= maxKd);
      // const statusMatch = !filters.status || item.status === filters.status;
      const statusMatch =
        !filters?.status ||
        (filters?.status?.toLowerCase() === 'covered'
          ? item?.status?.toLowerCase() !== 'not covered' &&
            item?.status !== ' ' &&
            item?.status?.length > 0 &&
            item?.status !== ''
          : item?.status?.toLowerCase() === filters?.status?.toLowerCase());
      const positionMatch =
        !filters?.position ||
        (filters?.position?.toLowerCase() === 'not ranking'
          ? item?.dr === null || item?.dr === '-'
          : filters?.position === '0'
          ? item?.dr === 0
          : !minVolume &&
            !maxVolume &&
            item?.dr >= minPosition &&
            item?.dr <= maxPosition);
      const intentMatch =
        !filters?.intent ||
        filters?.intent
          ?.map((i) => i.toLowerCase())
          ?.some(
            (intent) =>
              item?.intent.toLowerCase() === intent ||
              (item?.foreignIntent &&
                item?.foreignIntent
                  ?.map((fi) => fi.toLowerCase())
                  ?.includes(intent))
          );
      const goldenKRMatch =
        (!minGoldenKR && !maxGoldenKR) ||
        (item?.goldenKR >= minGoldenKR && item?.goldenKR <= maxGoldenKR);
      const wordCountMatch =
        (!minWordCount && !maxWordCount) ||
        (item?.keyword?.split(' ').length >= minWordCount &&
          item?.keyword?.split(' ').length <= maxWordCount);
      const spamScoreMatch =
        !filters?.spamScore ||
        (filters?.spamScore?.toLowerCase() === 'not ranking'
          ? item?.spamScore === null || item?.spamScore === '-'
          : !minVolume &&
            !maxVolume &&
            item?.spamScore >= minSpamScore &&
            item?.spamScore <= maxSpamScore);
      return (
        volumeMatch &&
        kdMatch &&
        statusMatch &&
        intentMatch &&
        goldenKRMatch &&
        wordCountMatch &&
        positionMatch &&
        spamScoreMatch
      );
    });
  };

  const handleRequestSort = (property) => {
    const isAsc = valueToOrderBy === property && orderDirection === 'asc';
    setValueToOrderBy(property);
    setOrderDirection(isAsc ? 'desc' : 'asc');
  };

  const sortedData = [...filteredRowData]?.sort((a, b) => {
    const aValue = a[valueToOrderBy] ?? '';
    const bValue = b[valueToOrderBy] ?? '';

    // Default logic
    if (orderDirection === 'asc') {
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    }
    return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
  });
  return (
    <Fragment>
      <Box sx={{ marginBottom: '32px' }}>
        <Typography sx={BackLinkAllCss?.exploreReferringPagesSx}>
          {BackLinkAllTexts?.exploreReferringPages}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {/* Filter Select Box */}
        {rowData?.length > 0 ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Autocomplete
              disableClearable
              options={BackLinkAllTexts?.options}
              value={
                BackLinkAllTexts?.options?.find(
                  (opt) => opt.value === selectedFilter
                ) || null
              }
              getOptionLabel={(option: any) => option.label}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option?.label}>
                  {option.label}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  sx={{
                    cursor: 'pointer',
                    height: '40px',
                    '& .MuiOutlinedInput-root': {
                      height: '40px',
                      borderRadius: '4px',
                      paddingRight: '8px',
                      ...CustomPopoverCss?.input,
                      '& fieldset': {
                        borderColor: selectedFilter
                          ? 'var(--color-purple-deep-alt)'
                          : 'var(--color-text-tertiary)'
                      }
                    },
                    '& .MuiInputBase-input': {
                      padding: '10px 12px',
                      fontSize: 'var(--font-size-14)',
                      cursor: 'pointer'
                    },
                    '& .MuiInputLabel-root': {
                      color: 'var(--color-text-purple)'
                    }
                  }}
                  {...params}
                  label="Link Type"
                  InputLabelProps={{
                    shrink: !!selectedFilter,
                    sx: {
                      top: selectedFilter ? 0 : '50%',
                      transform: selectedFilter
                        ? 'translate(14px, -9px) scale(0.75)'
                        : 'translate(14px, -50%)',
                      fontSize: 'var(--font-size-14)',
                      backgroundColor: 'white',
                      px: '2px'
                    }
                  }}
                  inputProps={{
                    ...params.inputProps,
                    style: { cursor: 'pointer' },
                    readOnly: true // ✅ prevent typing for real
                  }}
                  InputProps={{

                    style: {
                      ...keywordOverviewCss?.autoCompleteInput,
                      height: '40px',
                      cursor: 'pointer'
                    },
                    ...params.InputProps,

                    endAdornment: (
                      <InputAdornment position="end">
                        <Box
                          //component="span"
                          sx={{
                            verticalAlign: 'middle',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            ...CustomPopoverCss?.endAdornmentBox
                          }}
                        >
                          {selectedFilter && (
                            <Divider
                              sx={CustomPopoverCss?.divider}
                              orientation="vertical"
                            />
                          )}
                          {selectedFilter ? (
                            <CloseIcon
                              onClick={(e) => {
                                e.stopPropagation(); // prevent dropdown from opening
                                setSelectedFilter('');
                                setPage(0);
                                setFilteredRowData(backLinkFilteredData); // reset to full list
                              }}
                              sx={{
                                cursor: 'pointer',
                                width: '20px',
                                ...CustomPopoverCss?.clearIcon
                              }}
                            />
                          ) : isFilterOpen ? (
                            <ExpandLess
                              sx={{
                                cursor: 'pointer',
                                ...CustomPopoverCss?.arrowIconSx
                              }}
                            />
                          ) : (
                            <ExpandMore
                              sx={{
                                cursor: 'pointer',
                                ...CustomPopoverCss?.arrowIconSx
                              }}
                            />
                          )}
                        </Box>
                      </InputAdornment>
                    ),
                    autoComplete: 'new-password'
                  }}
                  variant="outlined"
                />
              )}
              onChange={(_, selectedOption) => {
                const selectedValue = selectedOption?.value || '';
                setSelectedFilter(selectedValue);
                if (selectedValue) {
                  const updated = backLinkFilteredData?.filter(
                    (row) => row?.linkAttribute?.toLowerCase() === selectedValue
                  );
                  setPage(0);
                  setFilteredRowData(updated);
                } else {
                  setPage(0);
                  setFilteredRowData(backLinkFilteredData); // fallback
                }
              }}
              onOpen={() => setIsFilterOpen(true)}
              onClose={() => setIsFilterOpen(false)}
              openOnFocus
              sx={{
                ...keywordOverviewCss?.autoComplete,
                width: '176px',
                cursor: 'pointer'
              }}
            />
            <CustomDropdown
              labelText="Position"
              options={backLinkDrOptions}
              showFields={true}
              isBackLinks={true}
            />
            <CustomDropdown
              labelText="Position"
              options={backLinkSpamScoreOptions}
              showFields={true}
              isBackLinks={true}
              isSpamScore={true}
            />
            <Autocomplete
              disableClearable
              options={BackLinkAllTexts?.filtersOptions}
              value={
                BackLinkAllTexts?.filtersOptions.find(
                  (opt) => opt.value === filterState
                ) || null
              }
              getOptionLabel={(option: any) => option.label}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option.label}>
                  {option.label}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  sx={{
                    cursor: 'pointer',
                    height: '40px',
                    '& .MuiOutlinedInput-root': {
                      height: '40px',
                      borderRadius: '4px',
                      paddingRight: '8px',
                      ...CustomPopoverCss?.input,
                      '& fieldset': {
                        borderColor:
                          filterState !== null
                            ? 'var(--color-purple-deep-alt)'
                            : 'var(--color-text-tertiary)'
                      }
                    },
                    '& .MuiInputBase-input': {
                      padding: '10px 12px',
                      fontSize: 'var(--font-size-14)',
                      cursor: 'pointer'
                    },
                    '& .MuiInputLabel-root': {
                      color: 'var(--color-text-purple)'
                    }
                  }}
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    style: { cursor: 'pointer' },
                    readOnly: true // Prevent typing
                  }}
                  label="Lost"
                  InputLabelProps={{
                    shrink: filterState !== null,
                    sx: {
                      top: filterState !== null ? 0 : '50%',
                      transform:
                        filterState !== null
                          ? 'translate(14px, -9px) scale(0.75)'
                          : 'translate(14px, -50%)',
                      fontSize: 'var(--font-size-14)',
                      backgroundColor: 'white',
                      px: '2px'
                    }
                  }}
                  InputProps={{
                    //placeholder: 'Lost',
                    style: {
                      ...keywordOverviewCss?.autoCompleteInput,
                      height: '40px',
                      cursor: 'pointer'
                    },
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        <Box
                          //component="span"
                          sx={{
                            verticalAlign: 'middle',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            ...CustomPopoverCss?.endAdornmentBox
                          }}
                        >
                          {filterState !== null && (
                            <Divider
                              sx={CustomPopoverCss?.divider}
                              orientation="vertical"
                            />
                          )}
                          {filterState !== null ? (
                            <CloseIcon
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent dropdown from opening
                                setFilterState(null); // Reset filter state
                                setPage(0);
                                setFilteredRowData(backLinkFilteredData); // Reset to full list
                              }}
                              sx={{
                                cursor: 'pointer',
                                width: '20px',
                                ...CustomPopoverCss?.clearIcon
                              }}
                            />
                          ) : isFilterOpen ? (
                            <ExpandLess
                              sx={{
                                cursor: 'pointer',
                                ...CustomPopoverCss?.arrowIconSx
                              }}
                            />
                          ) : (
                            <ExpandMore
                              sx={{
                                cursor: 'pointer',
                                ...CustomPopoverCss?.arrowIconSx
                              }}
                            />
                          )}
                        </Box>
                      </InputAdornment>
                    ),
                    autoComplete: 'new-password'
                  }}
                  variant="outlined"
                />
              )}
              onChange={(_, selectedOption: any) => {
                const selectedValue = selectedOption?.value ?? null; // Use new state

                const filterData = backupFilteredRowData || [];
                setFilterState(selectedValue);
                if (selectedValue !== null) {
                  const updated = filterData?.filter(
                    (row) => row?.lost === selectedValue
                  );
                  setPage(0);
                  setFilteredRowData(updated);
                } else {
                  setPage(0);
                  let updated = backLinkFilteredData;
                  if (selectedFilter) {
                    updated = backLinkFilteredData?.filter(
                      (row) =>
                        row?.linkAttribute?.toLowerCase() === selectedFilter
                    );
                  }
                  setFilteredRowData(updated);
                }
              }}
              onOpen={() => setIsFilterOpen(true)}
              onClose={() => setIsFilterOpen(false)}
              openOnFocus
              sx={{
                ...keywordOverviewCss?.autoComplete,
                width: '176px',
                cursor: 'pointer'
              }}
            />
          </Box>
        ) : (
          <Box></Box>
        )}
        <Button
          variant="outlined"
          startIcon={
            <img
              src={
                process.env.PUBLIC_URL + '/static/images/icons/upload_icon.svg'
              }
              style={{
                opacity:
                  filteredRowData?.length == 0 || !filteredRowData ? '0.3' : '1'
              }}
            />
          }
          sx={{
            height: '40px',
            fontWeight: 600,
            fontSize: 'var(--font-size-14)',
            padding: '10px 14px',
            border: '1px solid var(--color-text-muted-purple)',
            borderRadius: '6px'
          }}
          onClick={handleExportBtnClick}
          disabled={filteredRowData?.length == 0 || !filteredRowData}
        >
          {BackLinkAllTexts?.exportToCSV}
        </Button>
        <ExportCsvPopOver
          open={open}
          id={id}
          anchorEl={anchorEl}
          handleClose={handleClose}
          exportType={exportType}
          setExportType={setExportType}
          customRange={customRange}
          setCustomRange={setCustomRange}
          csvFormat={csvFormat}
          setCsvFormat={setCsvFormat}
          handleExport={handleExport}
          isBackLink={true}
        />
      </Box>
      <TableContainer
        component={Paper}
        square
        style={{
          marginTop: '15px',
          boxShadow: 'none',
          outline: '1px solid rgb(250,250,250)'
        }}
      >
        <Table>
          {/* Table Head  */}
          <TableHead>
            <TableRow sx={KeywordOverviewTableCss?.tableHeaderRow}>
              {headers?.map((title, i) => {
                const dataKey = columnToDataKeyMap[title] || title;
                return (
                  <StyledTableCell key={i}>
                    {title !== ' ' && ((i >= 1 && i <= 3) || i == 5) ? (
                      <>
                        <TableSortLabel
                          sx={KeywordOverviewTableCss?.tableSortLabel}
                          active={valueToOrderBy === dataKey}
                          direction={
                            valueToOrderBy === dataKey
                              ? (orderDirection as 'asc' | 'desc')
                              : 'asc'
                          }
                          onClick={() => handleRequestSort(dataKey)}
                        >
                          <CustomTooltip
                            title={
                              <Box>
                                <Typography
                                  sx={
                                    keywordResearchDashBoardCss?.customTollTipText
                                  }
                                >
                                  {backLinkTooltips[i]}{' '}
                                  {i == 0 && (
                                    <span
                                      onClick={() => {
                                        openNewTab(
                                          keywordOverviewTexts?.backLinkTutorialsLink
                                        );
                                      }}
                                      style={
                                        keywordResearchDashBoardCss?.linkStyle
                                      }
                                    >
                                      {'Watch the tutorial'}
                                    </span>
                                  )}
                                  {i == 0 &&
                                    ' to learn how to interpret this data.'}
                                  {i == 2 && (
                                    <span
                                      onClick={() => {
                                        openNewTab(
                                          keywordOverviewTexts?.backLinkTutorialsLink
                                        );
                                      }}
                                      style={
                                        keywordResearchDashBoardCss?.linkStyle
                                      }
                                    >
                                      {'tutorial'}
                                    </span>
                                  )}
                                  {i == 2 && ' to learn more.'}
                                </Typography>
                              </Box>
                            }
                            placement="bottom"
                            arrow
                          >
                            <HelpIcon
                              sx={{
                                mr: 1,
                                ...commonTableHeaderIcon?.helpIcon,
                                ...KeywordOverviewResultCardsCss?.helpIconHead
                              }}
                              fontSize="small"
                            />
                          </CustomTooltip>
                          <span style={{ color: 'rgba(0,0,0,0.8)' }}>
                            {title}
                          </span>
                        </TableSortLabel>
                      </>
                    ) : (
                      <>
                        <CustomTooltip
                          title={
                            <Box>
                              <Typography
                                sx={
                                  keywordResearchDashBoardCss?.customTollTipText
                                }
                              >
                                {backLinkTooltips[i]}{' '}
                                {i == 0 && (
                                  <span
                                    onClick={() => {
                                      openNewTab(
                                        keywordOverviewTexts?.backLinkTutorialsLink
                                      );
                                    }}
                                    style={
                                      keywordResearchDashBoardCss?.linkStyle
                                    }
                                  >
                                    {'Watch the tutorial'}
                                  </span>
                                )}
                                {i == 0 &&
                                  ' to learn how to interpret this data.'}
                                {i == 2 && (
                                  <span
                                    onClick={() => {
                                      openNewTab(
                                        keywordOverviewTexts?.backLinkTutorialsLink
                                      );
                                    }}
                                    style={
                                      keywordResearchDashBoardCss?.linkStyle
                                    }
                                  >
                                    {'tutorial'}
                                  </span>
                                )}
                                {i == 2 && ' to learn more.'}
                              </Typography>
                            </Box>
                          }
                          placement="bottom"
                          arrow
                        >
                          <HelpIcon
                            sx={{
                              mr: 1,
                              ...commonTableHeaderIcon?.helpIcon,
                              ...KeywordOverviewResultCardsCss?.helpIconHead
                            }}
                            fontSize="small"
                          />
                        </CustomTooltip>
                        <span style={{ color: 'rgba(0,0,0,0.8)' }}>
                          {title}
                        </span>
                      </>
                    )}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {loader ? (
              Array.from({
                length: Math.max(3, 3)
              }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {Array.from({ length: 7 }).map((_, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <Skeleton
                        variant="rectangular"
                        animation="wave"
                        width={
                          cellIndex === 0
                            ? 120
                            : cellIndex === 1
                            ? 200
                            : cellIndex === 2
                            ? 150
                            : '80%' // Adjust widths accordingly
                        }
                        height={20}
                        sx={{
                          borderRadius: '100px',
                          marginTop: '8px',
                          marginBottom: '8px',
                          padding: '5px'
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : filteredRowData?.length == 0 ? (
              <TableRow>
                <TableCell
                  colSpan={9}
                  align="center"
                  sx={{ paddingLeft: '5px !important' }}
                >
                  {' '}
                  <Box sx={ListDataTableCss?.rowBoxSx}>
                    <Typography sx={ListDataTableCss?.noKeywordsLists}>
                      {BackLinkAllTexts?.noDataFound}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              sortedData
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                ?.map((row, i) => <BackLinksRow key={i} row={row} />)
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {filteredRowData?.length > 0 && (
        <Box sx={BackLinkAllCss?.paginationBox}>
          {(rowData?.length >= 1000 && !getIsMore) ||
          (nextToken && getIsMore) ? (
            <Button
              sx={BackLinkAllCss?.getMoreBacklinksBtn}
              onClick={() => {
                if (!getMoreLoader) {
                  setSelectedFilter('');
                  setFilterState(null);
                  dispatch(
                    setBackLinkFilters({
                      searchVolume: null,
                      kd: null,
                      position: null,
                      intent: null,
                      keywordGoldenRation: null,
                      wordCount: null,
                      spamScore: null
                    })
                  );
                  setPage(0);
                  setFilteredRowData(backLinkFilteredData);
                  getBackLinksDetailsFunc(true);
                }
              }}
            >
              {getMoreLoader ? (
                <CircularProgress size={24} />
              ) : (
                <Typography sx={BackLinkAllCss?.getMoreBacklinksText}>
                  {BackLinkAllTexts?.loadMore}
                </Typography>
              )}
            </Button>
          ) : (
            <Box></Box>
          )}
          <TablePagination
            sx={{ display: 'flex', justifyContent: 'end' }}
            rowsPerPageOptions={[10, 50, 100, 500, 1000]}
            component="div"
            count={filteredRowData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      )}
      <CommonModal
        open={openExportModal}
        handCloseModal={handleExportModalClose}
        title=""
        closebtn={false}
      >
        <ExportCsvModal
          handleExportModalClose={handleExportModalClose}
          handleDownload={exportToCSV}
        />
      </CommonModal>
    </Fragment>
  );
};

export default BacklinksDataTable;
